"use client";

import { useSelection } from "@frend-digital/centra/client";
import clsx from "clsx";
import { ComponentProps } from "react";
import styles from "./GeoSelector.module.css";

export const GeoStatus = ({ className, ...props }: ComponentProps<"div">) => {
  const { data } = useSelection({
    select: data => {
      return {
        lang: data.location?.language?.name,
        countryCode: data.location?.country,
        currency: data.selection?.currency,
      };
    },
  });

  return (
    <div className={clsx(styles.geoStatus, className)} {...props}>
      <span>{data?.lang}</span> <span className={styles.seperator} />{" "}
      <span>
        {data?.countryCode} ({data?.currency})
      </span>
    </div>
  );
};
